<!-- 权益活动H5-登录表单 -->
<template>
  <div class="right-activity-login">
    <div class="card-title">{{ title || '权益领取' }}</div>
    <div class="form-item">
      <van-field
        v-model.trim="form.phone"
        type="tel"
        maxlength="11"
        placeholder="请输入手机号"
        :border="false"
      >
        <template #left-icon>
          <span class="field-icon">+86</span>
        </template>
      </van-field>
    </div>
    <div class="form-item">
      <van-field
        v-model.trim="form.captchaCode"
        type="digit"
        maxlength="6"
        placeholder="请输入验证码"
        :border="false"
      >
        <template #button>
          <span
            class="code-btn"
            :class="{ disabled: countDown > 0 || codeLoading }"
            @click="getCode"
          >{{ countDown > 0 ? `${countDown}s后重发` : (codeLoading ? '发送中...' : '获取验证码') }}</span>
        </template>
      </van-field>
    </div>
    <button class="submit-btn" :disabled="loginLoading" @click="submit">登录</button>
    <div class="card-footer"></div>
  </div>
</template>
<script>
import { sendCaptcha, login } from '@/api/rightActivityH5'

const COUNT_DOWN_SECONDS = 60

export default {
  name: 'RightActivityLoginForm',
  props: {
    activityNo: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        phone: '',
        captchaCode: '',
      },
      countDown: 0,
      timer: null,
      codeLoading: false,
      loginLoading: false,
    }
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    // 获取验证码（仅接口成功才倒计时）
    getCode() {
      if (this.countDown > 0 || this.codeLoading) return
      if (!this.checkPhone()) return
      this.codeLoading = true
      sendCaptcha({
        phone: this.form.phone,
        bizType: this.activityNo,
      }).then(res => {
        if (res.code !== 0) {
          this.$toast.fail(res.message || '验证码发送失败')
          return
        }
        this.$toast.success('验证码已发送')
        this.startCountDown()
      }).catch(() => {
        // 网络异常由 request 拦截器统一提示
      }).finally(() => {
        this.codeLoading = false
      })
    },
    // 登录
    submit() {
      if (!this.checkPhone()) return
      if (!/^\d{6}$/.test(this.form.captchaCode)) return this.$toast.fail('请输入6位验证码')
      if (this.loginLoading) return
      this.loginLoading = true
      login({
        phone: this.form.phone,
        captchaCode: this.form.captchaCode,
        bizType: this.activityNo,
      }).then(res => {
        if (res.code !== 0) {
          this.$toast.fail(res.message || '登录失败')
          return
        }
        this.clearTimer()
        this.$emit('success', res.data)
      }).catch(() => {
        // 网络异常由 request 拦截器统一提示
      }).finally(() => {
        this.loginLoading = false
      })
    },
    checkPhone() {
      if (!/^1\d{10}$/.test(this.form.phone)) {
        this.$toast.fail('请输入正确的手机号')
        return false
      }
      return true
    },
    startCountDown() {
      this.clearTimer()
      this.countDown = COUNT_DOWN_SECONDS
      this.timer = setInterval(() => {
        this.countDown -= 1
        if (this.countDown <= 0) this.clearTimer()
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.countDown = 0
    },
  },
}
</script>
<style lang="less">
/* bank rootValue=37.5，本项目=75，样式 px 按 2 倍书写以对齐视觉尺寸 */
.right-activity-login {
  padding: 48px 36px 40px;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 16px 48px rgba(31, 45, 77, 0.12);
  backdrop-filter: blur(6px);

  .card-title {
    font-size: 40px;
    font-weight: 600;
    color: #1f2d4d;
    text-align: center;
    margin-bottom: 60px;
  }
  .form-item {
    margin-top: 32px;
    border-radius: 20px;
    background: #f5f6fa;
    overflow: hidden;
    .van-cell {
      padding: 24px 28px;
      background: transparent;
      font-size: 30px;
    }
    .van-field__left-icon {
      display: flex;
      align-items: center;
      margin-right: 20px;
      padding-right: 20px;
      border-right: 1px solid #dfe2ea;
    }
  }
  .field-icon {
    font-size: 30px;
    color: #1f2d4d;
  }
  .code-btn {
    font-size: 28px;
    color: #e04242;
    &.disabled {
      color: #b0b6c3;
    }
  }
  .submit-btn {
    width: 100%;
    height: 92px;
    margin-top: 48px;
    border: none;
    border-radius: 46px;
    background: linear-gradient(90deg, #ff7a59 0%, #e04242 100%);
    color: #fff;
    font-size: 34px;
    letter-spacing: 4px;
    &:disabled {
      opacity: 0.6;
    }
  }
  .card-footer {
    margin-top: 28px;
    font-size: 24px;
    color: #a5abb9;
    text-align: center;
  }
}
</style>
